import * as React from "react";
import { Label, Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import "../popup/addpopup.scss";
import {
  createChildEntityGroup,
  updateChildEntityGroup,
} from "@services/entity-mapping.service";
import { toast } from "react-toastify";
import { sanitizeInput } from "@_common/dompurify";
import { clientAdminPublicFileUpload } from "@services/client-list.service";

interface IChoicePopupProps {
  isOpen: boolean;
  handleModal: () => void;
  handleModalCancel: () => void;
  parent_info: any;
  parent_index: number | unknown;
  getEntityList: (id: string, entity_parent: any) => void;
  editEntity: boolean;
  paramsValue: string;
  childEntityList: any;
  setEditEntity: any;
}

const AddChildGroupEntity: React.FunctionComponent<IChoicePopupProps> = (
  props
) => {
  const [entity_name, setEntity_name] = React.useState("");
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState<string>("");
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null);

  React.useEffect(() => {
    setEntity_name(getValue(props, `parent_info.entity_name`, ""));
    const logo = getValue(props, `parent_info.entity_logo`, "");
    if (logo) {
      setPreviewImage(logo);
    } else {
      setPreviewImage("");
    }
  }, [getValue(props, `parent_info`, "")]);

  const handleSubmit = async () => {
    if (!entity_name) {
      toast.error("Entity Name is mandatory.");
      return;
    }

    setSubmitLoading(true);

    try {
      let uploadedLogoId: string | null = null;

      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);

        const resp = await clientAdminPublicFileUpload(formData);
        if (resp.statusCode === 201) {
          uploadedLogoId = resp.data.id;
        } else {
          toast.error("Logo upload failed. Please try again.");
          setSubmitLoading(false);
          return;
        }
      }

      let payload: any = {
        entity_name: entity_name.trim(),
        entity_group: getValue(props, `parent_info.id`, ""),
        entity_parent: getValue(props, `paramsValue`, "")
          ? parseInt(getValue(props, `paramsValue`, "").split("_")[0])
          : "",
        ...(uploadedLogoId && { entity_logo: uploadedLogoId }),
      };

      Object.keys(payload).forEach((key) => {
        if (!payload[key]) {
          delete payload[key];
        }
      });

      let resp;
      if (props.editEntity) {
        resp = await updateChildEntityGroup(
          getValue(props, `parent_info.entity_id`, ""),
          payload
        );
      } else {
        resp = await createChildEntityGroup(payload);
      }

      if (resp) {
        toast.success(getValue(resp, `message`, "Success"));
        props.getEntityList(
          getValue(props, `parent_info.id`, ""),
          parseInt(getValue(props, `paramsValue`, "").split("_")[0])
        );
        props.handleModalCancel();
        setEntity_name("");
        setPreviewImage("");
        setSelectedFile(null);
        props.setEditEntity(false);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  let parentEntity =
    getValue(
      props,
      `childEntityList[${
        getValue(props, `paramsValue`, "").split("_")[1]
      }].length`,
      0
    ) > 0
      ? getValue(
          props,
          `childEntityList[${
            getValue(props, `paramsValue`, "").split("_")[1]
          }]`,
          []
        ).filter(
          (item: any) =>
            item.id == getValue(props, `paramsValue`, "").split("_")[0]
        )
      : [];

  return (
    <Modal
      isOpen={getValue(props, `isOpen`, "")}
      toggle={() => {
        props.handleModalCancel();
        props.setEditEntity(false);
      }}
      centered
      className="common-popup-spacing"
      autoFocus={false}
    >
      <section className="add-popup-wrapper">
        <h3 style={{ textAlign: "center", marginTop: "20px" }}>Group Entity</h3>
        <div className="common-popup-spacing__popup">
          {getValue(parentEntity, `length`, 0) > 0 ? (
            <p className="mb-2 ">
              Parent Entity :{" "}
              <span style={{ color: "#266ef1" }}>
                {getValue(parentEntity, `[${0}].entity_name`, 0)}
              </span>
            </p>
          ) : (
            ""
          )}

          <p className="mb-2 mt-2">
            Group Level :{" "}
            <span style={{ color: "#266ef1" }}>
              {getValue(props, `parent_info.group_level`, "")}
            </span>
          </p>
          <p className="mb-2 ">
            Group Name :{" "}
            <span style={{ color: "#266ef1" }}>
              {getValue(props, `parent_info.group_name`, "")}
            </span>
          </p>

          <br />
          <div className="add-popup-wrapper__form-group form-group">
            <Label>Group Entity Name * </Label>
            <InputField
              inputType="TEXT"
              placeholder="Enter Group Entity Name"
              name={"text"}
              value={entity_name}
              id={"text"}
              onChange={(e: any) =>
                setEntity_name(sanitizeInput(e.target.value))
              }
              autoFocus={true}
            />
          </div>
          {getValue(props, `parent_info.group_level`, "") === 1 ? (
            <div>
              <label className="org-profile-wrapper-image cursor-pointer">
                <img
                  src={
                    previewImage
                      ? previewImage
                      : "https://juliaja.nl/wp-content/uploads/2021/04/noimagefound24-1024x576.png"
                  }
                  width={400}
                  height={50}
                  alt="Entity Logo"
                />
                <input
                  type="file"
                  onChange={handleChangeFile}
                  className={`${
                    previewImage ? "d-none" : "w-[400px] h-[50px]"
                  }`}
                  accept="image/*"
                />
              </label>
              <div className="mt-2">
                <p className="org-profile-wrapper__details-text">
                  <span>
                    Preferred Image Size: 240px x 240px @ 72 DPI Maximum size of
                    1MB.
                  </span>
                </p>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="add-popup-wrapper__cta-wrapper">
            <button
              onClick={() => {
                props.handleModalCancel();
                props.setEditEntity(false);
                setPreviewImage("");
              }}
              className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
            >
              Cancel
            </button>
            <button
              className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading
                ? "Please wait..."
                : props.editEntity
                ? "Update"
                : "Submit"}
            </button>
          </div>
        </div>
        <div className="footer-wrapper d-flex justify-content-between">
          <img src="/images/building-illustration.svg" className="img-fluid" />
        </div>
      </section>
    </Modal>
  );
};

export default AddChildGroupEntity;
